import { useState } from "react";
import MainLayout from "../components/CommonComponents/MainLayout";
import CustomerTable from "./CustomerTable";
import AddCustomerModal from "../components/superadmin/AddCustomerModal";
import { deleteCustomer } from "../services/customerApi"; //API 
import { showSuccessToast, showErrorToast } from "../utils/toast";

export default function SuperAdminDashboard() {
  // trigger table refresh
  const [refreshFlag, setRefreshFlag] = useState(false);
  // modal state (open/close + customer data)
  const [modal, setModal] = useState({ isOpen: false, customer: null });
  // when edit button is clicked (set selected customer)
  const handleEdit = (customer) => {
    setModal({ isOpen: true, customer });
  };
  // delete customer from DB
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this customer?")) return;
    try {
      await deleteCustomer(id);
      setRefreshFlag((prev) => !prev); // trigger re-fetch after delete
      showSuccessToast("Customer deleted successfully");
    } catch (error) {
      console.error("Delete failed:", error);
      showErrorToast("Delete failed. Check backend logs.");
    }
  };
  // close modal
  const handleCloseModal = () => {
    setModal({ isOpen: false, customer: null });
  };
  // when user is added or edited
  const handleUserAddedOrUpdated = () => {
    setRefreshFlag((prev) => !prev);
    setModal({ isOpen: false, customer: null });
  };

  return (
    <MainLayout>
      <div className="pt-6">
        <CustomerTable
          refreshTrigger={refreshFlag}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
        {/* Add/Edit Modal */}
        {modal.isOpen && (
          <AddCustomerModal
            editData={modal.customer}
            onClose={handleCloseModal}
            onUserAddedOrUpdated={handleUserAddedOrUpdated}
          />
        )}
      </div>
    </MainLayout>
  );
}
